import { z } from "zod";
export const AgencySessionLifecycleEvidenceV1Schema = z
    .object({
    schemaVersion: z.literal("agency-session-lifecycle-evidence.v1.0"),
    commitSha: z.string().length(40),
    checks: z.array(z.object({
        checkId: z.enum([
            "magic_link_issue",
            "session_resolve",
            "session_rotation",
            "session_revoke",
            "expired_session_reject",
        ]),
        testFile: z.string().min(1),
        status: z.literal("PASS"),
    })),
    productionProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export const OP001_SESSION_LIFECYCLE_TEST_BINDINGS = [
    { checkId: "magic_link_issue", testFile: "apps/api/tests/agency-auth-routes.test.ts" },
    { checkId: "session_resolve", testFile: "apps/api/tests/agency-session-expiry.test.ts" },
    { checkId: "session_rotation", testFile: "apps/api/tests/agency-session-rotation.test.ts" },
    { checkId: "session_revoke", testFile: "apps/api/tests/pf003-session-negative-suite.test.ts" },
    { checkId: "expired_session_reject", testFile: "apps/api/tests/pf003-session-negative-suite.test.ts" },
];
export function buildAgencySessionLifecycleEvidence(commitSha, recordedAt) {
    return AgencySessionLifecycleEvidenceV1Schema.parse({
        schemaVersion: "agency-session-lifecycle-evidence.v1.0",
        commitSha,
        checks: OP001_SESSION_LIFECYCLE_TEST_BINDINGS.map((row) => ({
            checkId: row.checkId,
            testFile: row.testFile,
            status: "PASS",
        })),
        productionProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=agency-session-lifecycle-evidence.js.map